const stats = [
  { number: '500+', label: 'Trade Vendor Relationships', icon: 'ri-store-2-line' },
  { number: '1,200+', label: 'Projects Supported', icon: 'ri-building-2-line' },
  { number: '98%', label: 'Client Satisfaction Rate', icon: 'ri-star-line' },
  { number: '24h', label: 'Average Response Time', icon: 'ri-time-line' },
];

export default function TrustStats() {
  return (
    <section className="bg-[#2B2B2B] py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 bg-[#C5A572]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-[#C5A572] text-xl`}></i>
              </div>
              <div className="text-4xl font-bold text-white mb-2">{stat.number}</div>
              <div className="text-gray-400 text-sm leading-snug">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
